import React from 'react';
import { PageTitle, PageContent, PageLead } from 'components/Pages';
import OrderDetails from 'components/OrderDetails';

const Section = ({ id, order }) => {
    return (
        order && (
            <section className="page">
                <PageTitle url={`/orders`}>Szczegoły zamówienia nr {id}</PageTitle>
                <PageLead>
                    <p className="text-center">Poniżej znajdziesz szczegółowe informacje o Twoim zamówieniu</p>
                </PageLead>
                <PageContent>
                    <OrderDetails {...order} mode="details" />
                </PageContent>
                <PageLead size="small">
                    <p>
                        Jeśli masz jakiekolwiek pytania dotyczące Twojego zamówienia, prosimy,{' '}
                        <a href="https://garneczki.pl/kontakt">skontaktuj się z nami</a>, odpowiemy możliwie
                        najszybciej!
                    </p>
                </PageLead>
            </section>
        )
    );
};

export default Section;
